import { useEffect, useState } from "react";
import { ElementStore, ReactFormGenerator } from "react-form-builder2";
import { useDispatch, useSelector } from "react-redux";
// import { fetchSurveyForm, fetchSurveyFormClear, submitSurveyForm, submitSurveyFormClear } from "../../redux/survey/action";
import { clickStreamUser, SessionKeys } from "../../utils/AppUtils";
import _ from "lodash";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../Loader/Loader";
import ConfirmModal from "../modal/ConfirmModal";
import {
  showSurvey,
  showSurveyClear,
  submitSurvey,
  submitSurveyClear,
} from "../../redux/learningPath/actions";
import "./FormBuilder.scss";
import CongPopupAnimation from "../Course/CongPopupAnimation";
import BreadCrumbComponent from "../NewDesign/Misc/BreadCrumb/BreadCrumbComponent";
import FormRender from "./FormRender";
import CONFIG from "../../utils/config";
const FormGeneratorSection = ({ isMobile }) => {
  const dispatch = useDispatch();
  const { surveyId } = useParams();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const learningType = params.get("type");
  // const string = params.get("json");
  // let decodedString = atob(string);
  // let json = JSON.parse(decodedString);

  const stringObj = params.get("paramsObj");
  let decodedStringObj = atob(stringObj);
  let jsonObj = JSON.parse(decodedStringObj);
  const entityId = jsonObj.entityId;
  const lp_progress = jsonObj.lp_progress;
  const canEdit = params.get("canEdit");
  const user_id = params.get("user_id");

  const navigate = useNavigate();

  const [answersData, setAnswersData] = useState([]);
  const [formJSON, setFormJSON] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [heading, setHeading] = useState("");
  // const [formDataAns, setFormDataAns] = useState([])
  const [infoModal, setInfoModal] = useState(false);
  const [showInfoModalMsg, setShowInfoModalMsg] = useState("");
  const [surveyTitle, setSurveyTitle] = useState("");
  const [builder_id, setBuilder_id] = useState("");

  const surveyData = useSelector(
    (state) => state.learningPath.showSurveyListing
  );
  const submitSurveyData = useSelector(
    (state) => state.learningPath.submitSurveyListing
  );

  const [surveyRes, setSurveyRes] = useState({});

  const [isShowCongrat, setIsShowCongrat] = useState(false);
  const [isAnimCompleted, setIsAnimCompleted] = useState(false);

  useEffect(() => {
    if (entityId) {
      window.scrollTo(0, 0);
      if (isMobile) {
        let scrollToTop = { message: "scrollToTop" };

        window.parent.postMessage(
          JSON.stringify(scrollToTop),
          CONFIG.API_URL_BROKER_ADMIN
        );
      }
      console.log("Survey ID", surveyId);
      setIsLoading(true);
      let obj = {
        token: isMobile
          ? localStorage.getItem(SessionKeys.API_TOKEN)
          : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        survey_id: entityId,
      };
      if (user_id) {
        obj.user_id = user_id;
      }
      dispatch(
        showSurvey({
          module: "show-survey",
          postData: obj,
        })
      );
    }
  }, [entityId]);

  useEffect(() => {
    if (!_.isEmpty(surveyData)) {
      console.log("surveyData", surveyData);
      setIsLoading(false);
      if (surveyData.status === "success") {
        console.log("Survey Data", surveyData);
        let surveyRes1 = surveyData?.payload?.payload;
        if (surveyRes1?.response_json) {
          //   const answerData = JSON.parse(surveyRes1?.response_json)
          //     ?.map((ans) => {
          //       const match = JSON.parse(surveyRes1?.form_json)?.find(
          //         (f) => f.id === ans.id
          //       );
          //       if (!match) return null;

          //       if (match.element === "Checkboxes" && Array.isArray(ans.answer)) {
          //         return {
          //           name: match.field_name,
          //           value: ans.answer.map((optionText) => {
          //             const option = match.options.find((opt) => opt.text === optionText);
          //             return option ? option.value : null;
          //           }).filter(Boolean),
          //         };
          //       }

          //       return {
          //         name: match.field_name,
          //         value: ans.answer,
          //       };
          //     })
          //     .filter(Boolean);

          //   console.log("answers---", answerData);
          setAnswersData(JSON.parse(surveyRes1?.response_json));
        }
        setFormJSON(JSON.parse(surveyRes1?.form_json));
        setSurveyTitle(surveyRes1?.title);
        setSurveyRes(surveyRes1);
        window.scrollTo(0, 0);
      } else {
        setShowInfoModalMsg("Unable to get survey, please try again later.");
        setInfoModal(true);
      }
      // window.scrollTo(0, 0)
      dispatch(showSurveyClear());
    }
  }, [surveyData]);

  useEffect(() => {
    if (infoModal) {
      setTimeout(() => {
        setInfoModal(false);
        setShowInfoModalMsg("");
      }, 5000);
    }
  }, [infoModal]);

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 1000);
    ElementStore.subscribe((state) => {
      console.log(state);
      // setFormJSON(state.data)
    });
  }, []);

  useEffect(() => {
    if (learningType === "elearning") {
      setHeading("Course Quality Assessment Form");
    } else if (learningType === "virtual") {
      setHeading("Virtual Session Assessment Form");
    }
  }, [learningType]);

  useEffect(() => {
    if (!_.isEmpty(submitSurveyData)) {
      setIsLoading(false);
      if (submitSurveyData.status === "success") {
        setShowInfoModalMsg("Thank you for submitting your feedback.");
        setTimeout(() => {
          // window.history.back()
          setInfoModal(false);
          setTimeout(() => {
            if (
              surveyRes?.survey_optional ||
              lp_progress === 100 ||
              lp_progress === "100"
            ) {
              navigate("/learn/learningpath?tab=3");
            } else {
              setIsShowCongrat(true);
            }
          }, 500);
        }, 2000);
      } else {
        setShowInfoModalMsg(
          "Unable to submit your feedback, please try again later."
        );
      }
      // window.scrollTo(0, 0)
      dispatch(submitSurveyClear());
      setInfoModal(true);
    }
  }, [submitSurveyData]);

  const onChange = (values) => {
    console.log(values);
    // setFormDataAns(values)
  };

  const onSubmit = (formDataAns) => {
    console.log("Hello", formDataAns, formJSON);
    // return;
    console.log(formDataAns);
    if (!_.isEmpty(formDataAns)) {
      let qtsAns = [];
      for (let form of formJSON) {
        for (let data of formDataAns) {
          if (data.id === form.id) {
            let options = [];
            let value = data.value;
            console.log(form.elements);
            console.log(form.options);
            if (form.element === "Dropdown") {
              const selectedOption = form.options.find(
                (option) => option.value === data.value
              );
              console.log(
                "selected opt",
                selectedOption,
                form.options,
                data.value
              );
              value = selectedOption ? selectedOption.text : "";
            } else if (form.element === "RadioButtons") {
              let newValue = [];
              console.log(form.options);
              for (let r of form.options) {
                options.push(r.text);
                if (value.includes(r.key)) {
                  newValue.push(r.text);
                }
              }
              value = newValue;
            } else if (form.element === "Checkboxes") {
              let newValue = [];
              for (let r of form.options) {
                options.push(r.text);
                if (value.includes(r.key)) {
                  newValue.push(r.text);
                }
              }
              value = newValue;
            }
            qtsAns.push({
              question: form.label,
              answer: value,
              element: form.element,
              required: form.required,
              options: options,
              id: form?.id,
              field_name: form?.field_name,
            });
          }
        }
      }
      if (!_.isEmpty(qtsAns)) {
        console.log(qtsAns);
        // return;

        setIsLoading(true);
        dispatch(
          submitSurvey({
            module: "submit-survey",
            postData: {
              survey_id: entityId,
              // sesssion_id: sessionId,
              // segment_id: segmentId,
              // response_json: qtsAns,
              token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
              builder_id: surveyId,
              formJSON: qtsAns,
            },
          })
        );
      }
    }
  };
  //   const [breadCrumbData, setBreadCrumbData] = useState([
  //     {
  //       name: provider_name
  //         ? authBroker?.payload?.user?.config?.partner_menu_text !== undefined && !_.isEmpty(authBroker?.payload?.user?.config?.partner_menu_text)?
  //         authBroker?.payload?.user?.config?.partner_menu_text:
  //         "Learning Partners"
  //         : is_home
  //         ? "Home"
  //         : from_sub
  //         ? "Subscription"
  //         : "Learn",
  //       active: false,
  //       link: "",
  //       isLoading: false,
  //     },
  //     { name: "Learning Path", active: false, link: "", isLoading: false },
  //     { name: "-", active: false, link: "", isLoading: true },
  //   ]);
  const renderAlertCard = () => {
    return (
      <div
        className={`cal-alert alert-card d-flex justify-content-center ${
          infoModal ? "" : "d-none"
        }`}
      >
        <div className="shop-cart">
          <div className="shop-info justify-content-center">
            <p className="m-0">{showInfoModalMsg}</p>
          </div>
          <div className="view-cart-icon">
            <i
              className="fa fa-times cursor-pointer"
              aria-hidden="true"
              onClick={() => {
                setInfoModal(false);
                setShowInfoModalMsg("");
              }}
            ></i>
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (isShowCongrat) {
      setTimeout(() => {
        // if (via_lp === 'true' || from === "lp") {
        //   getSingleLPData()
        // } else if (via_cat === 'true') {
        //   getCoursesListingData()
        // }
      }, 2000);
    }
    if (isAnimCompleted) {
      //   if (userRole !== "manager" && !isGuest) {
      //     checkRankStatusFunc(dispatch, getRankStatus)
      //   }
      navigate("/learn/learningpath?tab=3");
      return () => {
        setIsAnimCompleted(false);
      };
    }
  }, [isShowCongrat, isAnimCompleted]);

  return (
    <>
      <Loader start={isLoading} />
      <section className="my-credit-points learningpaths builder-form surver-frms">
        <div className="container position-relative">
          {/* {renderAlertCard()} */}
          <div className="col-md-4 mb-4">
            <button
              className="btn btn-primary setup-button"
              onClick={() => {
                clickStreamUser("back-btn-session-video", {
                  userId: localStorage.getItem(SessionKeys.USER_ID),
                });
                navigate(-1);
              }}
            >
              Back
            </button>
          </div>
          {/* <BreadCrumbComponent crumbList={breadCrumbData} /> */}
          <div className="rows">
            <div className="mb-5 survey-sec ">
              <div class="survey-section">
                <div class="survey-header">
                  <img
                    src={
                      surveyRes?.survey_thumbnail
                        ? surveyRes?.survey_thumbnail
                        : "/images/module-img-III.png"
                    }
                    alt="Survey Icon"
                    class="survey-icon"
                  />
                  <div class="survey-text">
                    <h2>{surveyRes?.survey_title}</h2>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: surveyRes?.survey_desc,
                      }}
                    ></p>
                  </div>
                </div>

                <div class="survey-instructions">
                  <h3>Instructions</h3>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: surveyRes?.survey_inst,
                    }}
                  ></p>
                </div>
              </div>

              <div className="mt-5sd">
                <div className="w-30">
                  {canEdit === "0" ? (
                    <FormRender data={answersData} />
                  ) : !_.isEmpty(formJSON) && _.isArray(formJSON) ? (
                    <ReactFormGenerator
                      back_name="Back"
                      action_name="Submit"
                      answer_data={answersData}
                      form_action=""
                      form_method=""
                      data={formJSON}
                      locale="en"
                      onSubmit={onSubmit}
                      hide_actions={canEdit === "0" ? true : false}
                      read_only={canEdit === "0" ? true : false}
                      // onChange={onChange}
                    />
                  ) : (
                    ""
                  )}
                  {/* <div className="d-flex justify-content-end btnsecform mt-3">
                                            <div>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary-LR  setup-button"
                                                    onClick={onSubmit}
                                                >Submit</button>
                                            </div>
                                        </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <ConfirmModal
          confirmModal={infoModal}
          showModalMsg={showInfoModalMsg}
          setConfirmModal={setInfoModal}
          isConfirm={false}
          confirmId={""}
          confirmAction={() => {
            setInfoModal(false);
            setShowInfoModalMsg("");
          }}
          isRighIcon={""}
          isSuccess={true}
        />
      </section>

      {isShowCongrat ? ( //isShowCongrat
        <>
          <CongPopupAnimation
            title={surveyRes?.lp_name} //(via_lp==="true" || from === "lp") && isLPCompleted ?moduleData.lp_name:moduleData?.courseName
            lpPoints={0} //moduleData?.lp_points
            fromPage={2} //isLPCompleted ? 2 : isFree ? 0 : 1
            name={"survey"}
            setIsAnimCompleted={setIsAnimCompleted}
            via_lp={"true"} //via_lp
            lp_id={surveyRes?.lp_id} //lp_id
            isMobile={false} //isMobile
            isSurvey={true} //isSurvey
          />
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default FormGeneratorSection;
